export default "__VITE_ASSET__BmX84Ufs__"